/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * TSoft APIs
 * API Description for TSoft platform
 * OpenAPI spec version: 2.0
 */

export type AuthorizationStatus = (typeof AuthorizationStatus)[keyof typeof AuthorizationStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AuthorizationStatus = {
  AUTHORIZATION_STATUS_UNSPECIFIED: 'AUTHORIZATION_STATUS_UNSPECIFIED',
  AUTHORIZATION_STATUS_PENDING: 'AUTHORIZATION_STATUS_PENDING',
  AUTHORIZATION_STATUS_APPROVED: 'AUTHORIZATION_STATUS_APPROVED',
  AUTHORIZATION_STATUS_DECLINED: 'AUTHORIZATION_STATUS_DECLINED',
  AUTHORIZATION_STATUS_CANCELLED: 'AUTHORIZATION_STATUS_CANCELLED',
  AUTHORIZATION_STATUS_USED: 'AUTHORIZATION_STATUS_USED',
  UNRECOGNIZED: 'UNRECOGNIZED'
} as const
